<template>
	<div>
		<el-date-picker @change="getList()" value-format="yyyy-MM" size="small" v-model="query.month"
			style="width: 150px;margin-bottom: 10px;" type="month" placeholder="选择月">
		</el-date-picker>
		<el-button type="primary" size="mini" @click="exportYeJi" style="float: right;">导出</el-button>
		<el-table :data="list" v-loading="loading"
			:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
			:cell-style="{ 'text-align':'center'}">
			<el-table-column label="月份">
				<template>
					{{query.month}}
				</template>
			</el-table-column>
			<el-table-column label="id">
				<template slot-scope="{row}">
					{{row.workerId}}
				</template>
			</el-table-column>
			<el-table-column label="发型师">
				<template slot-scope="{row}">
					{{row.workerName}}
				</template>
			</el-table-column>
			<el-table-column label="总业绩">
				<template slot-scope="{row}">
					{{row.total | m}}
				</template>
			</el-table-column>
			<el-table-column label="目标">
				<template slot-scope="{row}">
					{{row.turnover | m}}
				</template>
			</el-table-column>
			<el-table-column label="业绩达标率">
				<template slot-scope="{row}">
					{{((row.total/row.turnover)*100).toFixed(2)}}%
				</template>
			</el-table-column>
			<el-table-column label="抖音">
				<template slot-scope="{row}">
					{{row.douYin | m}}
				</template>
			</el-table-column>

			<el-table-column label="会员提成">
				<template slot-scope="{row}">
					{{row.memberCommission | m}}
				</template>
			</el-table-column>
			<el-table-column label="新会员数">
				<template slot-scope="{row}">
					{{row.normalCount}}
				</template>
			</el-table-column>
			<el-table-column label="老会员数">
				<template slot-scope="{row}">
					{{row.memberCount}}
				</template>
			</el-table-column>
			<el-table-column label="差评">
				<template slot-scope="{row}">
					{{row.bad}}
				</template>
			</el-table-column>
			<el-table-column label="提成">
				<template slot-scope="{row}">
					{{row.commission | m}}
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	import {
		formatMoney
	} from '../../../utils/index.js'
	export default {
		filters: {
			m(value) {
				return '￥' + formatMoney(value / 100)
			}
		},
		data() {
			return {
				url: url(),
				list: [],
				query: {
					month: ''
				},
				loading: false
			}
		},
		mounted() {
			const date1 = new Date()
			const nowDay =
				`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}`
			this.query.month = nowDay
			this.getList()
		},
		methods: {
			getList() {
				this.loading = true
				this.$http.get("dWorker/workerYeJiByMonth?month=" + this.query.month).then(res => {
					if (res.body.code == 200) {
						this.list = res.body.data
					}
					this.loading = false
				})
			},
			exportYeJi() {
				let str = "dWorker/exportYeJi?month=" + this.query.month;
				window.location.assign(this.url + str);
			}
		},
	};
</script>

<style>
</style>